var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-light-gray border-radius--light text-center col-12"},[_c('button',_vm._g({staticClass:"btn bg-light-white pt-1 mb-3 mt-3 col-12 col-md-6 col-lg-6"},_vm.$listeners),[_c('div',[_c('i',{staticClass:"fas fa-file-plus pr-2 text-green"}),_c('span',{domProps:{"textContent":_vm._s(_vm.text)}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }